<template>
  <div class="instruction">
    <instruction-header />
    <instruction-body />
  </div>
</template>

<script>
import Header from "../components/instruction/Header";
import Body from "../components/instruction/Body";

export default {
  components: {
    "instruction-header": Header,
    "instruction-body": Body
  }
};
</script>

<style scoped></style>
